import styled from "styled-components"

import ErrorText from "../../ErrorText"

export const SpacedErrorText = styled(ErrorText)`
  margin-bottom: 20px;

  svg {
    margin-bottom: 0;
  }
`
